'use client'
import { AlertDescription as ChakraAlertDescription } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { AlertDescriptionProps } from './alert-description.types'

export default forwardRef(function Alert(
  props: AlertDescriptionProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraAlertDescription {...props} ref={ref} translate="no" />
})
